"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../context/AuthContext"
import { login } from "../redux/slices/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { EyeClosed, EyeOff } from "lucide-react"
import PhoneInput from "react-phone-input-2";
import { generateRecaptchaToken } from "../utils/recaptcha";

function LoginForm() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { setAuthenticatedUser } = useAuth()

  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [password, setPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [rememberMe, setRememberMe] = useState(false)
  const authError = useSelector((state) => state.auth.error);
  const [usePhone, setUsePhone] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    try {
      // Generate reCAPTCHA v3 token
      const recaptchaToken = await generateRecaptchaToken('login');

      const payload = usePhone
        ? { phone, password, recaptchaToken }
        : { email, password, recaptchaToken }

      const result = await dispatch(login(payload))

      if (login.fulfilled.match(result)) {
        setAuthenticatedUser(result.payload.data.user);
        window.location.href = "/session-check";
      } else if (login.rejected.match(result)) {
        // Handle rejected case - error will be in Redux state
        console.error("Login failed:", result.payload);
      }
    } catch (err) {
      console.error("Login error:", err);
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className="auth-card">
        <div className="auth-header">
          <h2 className="auth-title">Login Kaxaa Wallet</h2>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          {authError && <div className="error-alert">{authError}</div>}

          <div className="form-group m-0">
            <div className="d-flex justify-content-between align-items-center mb-1">
              <label className="required">{usePhone ? "Phone" : "Email"}</label>
              <div className="tabs-holder">
                <span
                  className={`${usePhone ? '' : 'active'}`}
                  onClick={() => setUsePhone(false)}
                >
                  Use email
                </span>
                <span
                  className={`${!usePhone ? '' : 'active'}`}
                  onClick={() => setUsePhone(true)}
                >
                  Use phone
                </span>
              </div>
            </div>
            {usePhone ? (
              // <input
              //   type="tel"
              //   placeholder="Enter your phone number"
              //   value={phone}
              //   onChange={(e) => setPhone(e.target.value)}
              //   required
              //   className="form-input form-control w-100"
              // />
              <PhoneInput
                country={"us"}   // default Pakistan flag
                value={phone}
                onChange={(value) => setPhone(value)}
                inputClass="form-input form-control w-100"
              />
            ) : (
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="form-input form-control w-100"
              />
            )}
          </div>

          <div className="form-group m-0">
            <div className="mb-1">
              <label className="required" htmlFor="password">Password</label>
            </div>
            <div className="password-input-container">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input form-control w-full"
              />
              <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
                {showPassword ? <EyeClosed size={'18'} /> : <EyeOff size={'18'} />}
              </button>
            </div>
          </div>

          <div className="d-flex justify-content-between align-items-center mb-3 mt-2">
            <div className="checkbox-group">
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                className="checkbox"
              />
              <label htmlFor="rememberMe" className="checkbox-label">
                Remember me
              </label>
            </div>
            <button type="button" className="link-button" onClick={() => navigate("/forgot-password")}>
              Forgot password?
            </button>
          </div>

          <button type="submit" className="auth-button" disabled={isLoading}>
            {isLoading ? (
              <div className="d-flex align-items-center justify-content-center">
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Signing In...
              </div>
            ) : (
              "Sign In"
            )}
          </button>

        </form>
      </div>
      <div className="auth-links mt-3">
        <div className="auth-switch">
          New to kaxaa wallet?
          <button type="button" className="link-button" onClick={() => navigate("/register")}>
            Create an account
          </button>
        </div>
      </div>
    </>
  )
}

export default LoginForm
